module.exports = global["jQuery"] = require("-!/root/project/node_modules/expose-loader/index.js?$!./jquery.js");